import React, { Component } from 'react'
import { Row, Col } from 'antd'
import { observer, inject } from 'mobx-react'
import styles from './Footer.module.css'
import classNames from 'classnames'

const LINK_BRAND = ['https://static.insta360.com/assets/mall/logo_insta360@2x.png', 'http://www.insta360.com/']

const LINK_SOCIAL = [
  ['https://static.insta360.com/assets/www/images/footer/facebook@2x.png', 'https://www.facebook.com/Insta360-832149753506055/'],
  ['https://static.insta360.com/assets/www/images/footer/instagram@2x.png', 'https://www.instagram.com/insta360/'],
  ['https://static.insta360.com/assets/www/images/footer/twitter@2x.png', 'https://twitter.com/insta360'],
  ['https://static.insta360.com/assets/www/images/footer/snapchat@2x.png','','https://static.insta360.com/assets/www/images/footer/snapchat-qrcode@2x.png'],
  ['https://static.insta360.com/assets/www/images/footer/youtube@2x.png', 'https://www.youtube.com/channel/UC3qWcF49rv8VMZO7Vg6kj5w'],
  ['https://static.insta360.com/assets/www/images/footer/wechat@2x.png', 'http://weibo.com/insta360'],
  ['https://static.insta360.com/assets/www/images/footer/weibo@2x.png', '','https://static.insta360.com/assets/www/images/footer/wechat-qrcode@2x.png'],
  ['https://static.insta360.com/assets/www/images/footer/youku@2x.png', 'https://i.youku.com/insta360']
]

@inject('app')
@observer
class Footer extends Component {
  render() {
    const { app } = this.props
    const { langs, locale } = app
    const { footer } = langs
    const LINK_MENU = footer.links
    const CONTACT = footer.contact
    const COPYRIGHT = footer.copyright

      return (
      <Row className={styles.component_footer}>
        <Col span={24} className="top">
          <Row className={classNames(styles.container, styles.top_container)}>
            <Col xs={24} md={4} className={styles.brand}>
              <a href={LINK_BRAND[1]} alt="" target="_blank"><img src={LINK_BRAND[0]} alt="" /></a>
            </Col>
            <Col xs={24} md={20} className={styles.social}>
              {
                  LINK_SOCIAL.map((social, key) => {

                  if (social[1] === '') {
                    return (
                      <a href={social[2]} key={key} target="_blank" className={styles.social_wrapper_qrcode}>
                        <img src={social[0]} alt="" />
                        <div className={styles.social_qrcode}>
                          <img src={social[2]} alt="" />
                        </div>
                      </a>
                    )
                  }
                    
                  return <a href={social[1]} key={key} target="_blank" className={styles.social_wrapper}><img src={social[0]} alt="" /></a>
                })
              }
            </Col>
          </Row>
        </Col>

        <Col span={24} className="middle">
          <Row className={styles.container}>
            <Row className={styles.blocks}>
              {
                LINK_MENU.map((menu, key) => {
                  return (
                    <Col xs={12} md={6} className="block" key={key} style={{ minHeight: '200px' }}>
                      <h3 className={styles.title}>{menu.title}</h3>
                      <ul className={styles.link_list}>
                        {
                          menu.links.map((link, key) => {
                            return (
                              <li key={key}>
                                <a href={link[1]} target="_blank">{link[0]}</a>
                              </li>
                            )
                          })
                        }
                      </ul>
                    </Col>
                  )
                })
              }
            </Row>
            <Col span={24} className={styles.contact}>
              <span>
                {CONTACT.tell}
              </span>
              <span>
                {CONTACT.work_day}
              </span>
            </Col>
          </Row>
        </Col>

        <Col span={24} className={styles.bottom}>
          <Row className={styles.container}>
            <Col xs={24} md={12}>
              <p className={styles.copyright}>{COPYRIGHT.right}</p>
            </Col>

            <Col xs={24} md={12} className={styles.text_right}>
              <span className="icp">{COPYRIGHT.icp}</span>
            </Col>
          </Row>
        </Col>
      </Row>)
    }
  }
export default Footer


// WEBPACK FOOTER //
// ./src/layouts/footer/Footer.js